// Producao MMC
export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'mmc';
export const apiLoginUrl = 'https://api.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'mmc-web@tacom.com.br';
export const password = 'MM(32w4b';

export const versaoSoftware = '4.4.16';
export const idioma = 'pt_BR'